import { Link } from 'react-router-dom';
import { Row, Col, Button, Radio, Modal } from 'antd';
import { HOME, REGISTER } from '../../utils/routeUtils';
import { lg, md, sm, xs } from '../../utils/components/afspControls';
import AfspUserControls from './controls/AfspUserControls';
import AfspLoginDod from './login/AfspLoginDod';
import AfspLoginFsdo from './login/AfspLoginFsdo';
import AfspLoginProvider from './login/AfspLoginProvider';
import AfspLoginAnalyst from './login/AfspLoginAnalyst';
import AfspLoginHome from './login/AfspLoginHome';
import { ssCommonUtils, ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';

const 
{ htmlStorage } = ssSessionUtils,
{ setEnvPrefix } = ssCommonUtils;

export default class AfspControls extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        if(this.props.hasOwnProperty('events')) this.state.events = this.props.events;
        if(this.props.hasOwnProperty('portalType')) this.state.portalType = this.props.portalType;
    }

    getView(s) {
        const
        { controlType, images, menu, size, state, services } = this.props,
        { usePathname, user } = images,
        c = controlType;
        switch(c) {
            case 'custom': return this.props.custom.component;

            case 'login': return (
                <div>
                    <Row>
                        <Col span={16} style={s[c].col1.style}>
                            <div style={s[c].col1.div1.style}>
                                <Button
                                    {...this.props.events.login}
                                    style={s[c].col1.div1.button.style}
                                    type='primary'
                                    icon='login'
                                >{'Log In'}</Button>
                            </div>
                            <div style={s[c].col1.div2.style}>
                                <Link to={setEnvPrefix(REGISTER)}>
                                    <Button
                                        style={s[c].col1.div2.button.style}
                                        type='default'
                                        icon='user-add'
                                    >{'Register'}</Button>
                                </Link>
                            </div>
                        </Col>
                        <Col span={8} style={s[c].col2.style}>
                            <div>
                                <Radio.Group style={{ position: 'relative' }} value={this.props.portalType} {...this.props.events.portal}>
                                    <div style={s[c].col2.div1.style}>
                                        <span style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                                            <Radio style={{ display: 'block', color: 'white' }} value="CANDIDATE">{'Candidate Portal'}</Radio>
                                        </span>
                                    </div>
                                    <div style={s[c].col2.div2.style}>
                                        <span style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                                            <Radio style={{ display: 'block', color: 'white' }} value="PROVIDER">{'Provider Portal'}</Radio>
                                        </span>
                                    </div>
                                </Radio.Group>
                            </div>
                        </Col>
                    </Row>
                </div>
            );

            case 'home': return (
                <div>
                    <Row>
                        <Col span={24} style={s[c].col1.style}>
                            <span style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                                <Button
                                    style={s[c].col1.button.style}
                                    type='primary'
                                    icon='home'
                                    onClick={() => {
                                        let home = null;
                                        try { home = htmlStorage().get('home').path; } 
                                        catch(err) { home = setEnvPrefix(HOME); }
                                        window.location.href = home;
                                    }}
                                >
                                    {'Home'}
                                </Button>
                            </span>
                        </Col>
                    </Row>
                </div>
            );

            case 'user': return <AfspUserControls
                services={this.props.services}
                styles={s[c]}
                images={images}
                menu={menu}
            />;

            case 'login-dod': return <AfspLoginDod state={state} services={services} size={size} />;
            case 'login-fsdo': return <AfspLoginFsdo state={state} services={services} size={size} />;
            case 'login-analyst': return <AfspLoginAnalyst state={state} services={services} size={size} />;
            case 'login-provider': return <AfspLoginProvider state={state} services={services} size={size} />;
            case 'login-home': return <AfspLoginHome state={state} services={services} size={size} />;
        }
    }

    render() {
        const { size, menu, controlType } = this.props;
        let modal = null, view = null;

        switch(size) {
            case 'na': view = null;
            case 'lg': view = this.getView(lg);
            case 'md': view = this.getView(md);
            case 'sm': view = this.getView(sm);
            case 'xs': view = this.getView(xs);
        }

        if(this.props.hasOwnProperty('menu') && menu.hasOwnProperty('settings')) {
            let
            component = menu.settings.component || null,
            modalProps = menu.settings.modalProps || { visible: false };
            modal = (
                <Modal {...modalProps}>
                    {component != null ? component() : null}
                </Modal>
            );
        }

        return (
            <div>
                {modal}
                {view}
            </div>
        )
    }
}
